import React, {Component} from "react";
import {FaIcon} from "../../../FaIcon";
import {DayPicker} from "react-day-picker";
import {Spinner} from "../../../Spinner";
import { withTranslation } from "react-i18next";


class LeadFilters extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        return (
            <section className="crm-filters">
                <form className="filter-options">
                    {this.renderTextFilter()}
                    {this.renderStateFilter()}
                    {this.renderDateFilter()}
                </form>
                {this.renderDownloadButton()}
            </section>
        );
    }

    renderTextFilter() {
        const { t } = this.props;
        return <div className="filter-input">
            <label><FaIcon iconName="search"/></label>
            <input name="text" type="text" onChange={this.props.onFilterChange}
                   value={this.props.filterValues.text}
                   placeholder={t('lead_filters.search_placeholder')}/>
            <button onClick={this.props.onHandleClearTextFilterClick} className="filter-clear"
                    type="button">
                <FaIcon iconName="times-circle"/>
            </button>
        </div>;
    }

    renderDateFilter() {
        return <div className="filter-date">
            <DayPicker
                mode="range"
                selected={{
                    from: this.props.filterValues.fromDate,
                    to: this.props.filterValues.toDate
                }}
                onSelect={this.props.onDateFilterChange}
                numberOfMonths={1}
                format="dd MMM yyyy"
            />
        </div>;
    }

    renderStateFilter() {
        const { t } = this.props;
        return <div className="filter-input">
            <select name="status" onChange={this.props.onFilterChange}>
                <option value=''>{t('lead_filters.any_state')}</option>
                <option value='WON'>{t('lead_state.won')}</option>
                <option value='OPEN'>{t('lead_state.open')}</option>
                <option value='LOST'>{t('lead_state.lost')}</option>
                <option value='NOT_APPLICABLE'>{t('lead_state.not_applicable')}</option>
            </select>
        </div>;
    }

    renderDownloadButton() {
        const { t } = this.props;
        if (this.props.isDownloading) {
            return <Spinner color="positive small"/>;
        } else {
            return <button title={t('lead_filters.export_leads')} onClick={this.props.onDownloadLeads} type="button" className="download">
                <FaIcon iconName="download"/>
            </button>
        }
    }
}

export default withTranslation()(LeadFilters);